import { Button, TableHead } from "@mui/material";
import SortIcon from "@src/assets/icons/SortIcon";
import Colors from "@src/constants/Colors";

import {
  StyledHeadBox,
  StyledHeadTableCell,
  StyledTableRow,
} from "../DataTable/styles";
import { Column, RowData } from "../DataTable/types";

interface TableHeaderTypes {
  dyColumns: Column[];
  sortHandler: (sortkey: string, sortId: string) => void;
  rowData: RowData[];
  sortBy: {
    tableName: string;
    order: string;
    label: string;
  };
  isDesktop: boolean;
}

const TableHeader = ({
  dyColumns,
  sortHandler,
  rowData,
  sortBy,
  isDesktop,
}: TableHeaderTypes) => {
  return (
    <TableHead>
      <StyledTableRow>
        {dyColumns?.map((column) => {
          return (
            <StyledHeadTableCell
              key={column.label}
              align={column.align}
              style={{
                minWidth: column.minWidth,
                position: column.freeze ? "sticky" : "unset",
                left: column.freeze ? 0 : "auto",
                backgroundColor: Colors.white,
                borderRight: isDesktop
                  ? `1px solid ${Colors.neutral_gray_300}`
                  : "",
              }}
              onClick={() => {
                if (rowData?.length > 0) {
                  sortHandler(column.label, column.id);
                }
              }}
            >
              <StyledHeadBox>
                <Button disableTouchRipple>
                  {column.label}
                  <SortIcon
                    order={
                      sortBy.label === column.label ||
                      sortBy.label === column.id
                        ? sortBy.order
                        : "normal"
                    }
                  />
                </Button>
              </StyledHeadBox>
            </StyledHeadTableCell>
          );
        })}
      </StyledTableRow>
    </TableHead>
  );
};

export default TableHeader;
